import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { fetchCondominiums, remove } from "../../helpers/api/condominium";
import FalconCardHeader from "../common/FalconCardHeader";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Input,
  CardFooter,
  Label,
} from "reactstrap";
import { isIterableArray } from "../../helpers/utils";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import FullPagination from "../common/pagination/FullPagination";
import ListItem from "../common/ListItem";
import { Toast } from "./../UI/toast/Toast";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import ButtonIcon from "../common/ButtonIcon";
import { faExclamation, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { SelectCondominium } from "../../actions/condominiumActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PreloadState, Or, Message } from "../UI/preloading/PreloadState";
import classNames from "classnames";
import Swal from "sweetalert2";
import bg from "./../../assets/img/illustrations/backup/4.png";
import Flex from "../common/Flex";
import { useParams } from "react-router-dom";
import ModalSelectedMoneyType from "./components/ModalSelectedMoneyType";
import { getConfigAsRoot } from "../../helpers/api/root";

const CondominiumList = ({
  setRedirectUrl,
  setRedirect,
  title = "Listado de condominios",
  showPagination,
}) => {
  const dispatch = useDispatch();
  const [textSearch, setTextSearch] = useState("");
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { token } = useSelector((state) => state.auth.user);
  const [openModalSelectMoney, setOpenModalSelectMoney] = useState(false);
  const [params, setParams] = useState({
    search: null,
    token: token,
  });

  const [prices, setPrices] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const fetchPrices = async () => {
      try {
        const { data } = await getConfigAsRoot();
        if (isMounted) setPrices(data);
      } catch (error) {
        console.error("Error fetching prices", error);
      }
    };
    fetchPrices();
    return () => {
      isMounted = false;
    };
  }, []);

  const {
    data,
    error,
    isLoading,
    mutate,
    meta,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(fetchCondominiums, params);

  useEffect(() => {
    let isMounted = true;
    isMounted && setRedirectUrl("/dashboard/condominiums/create");
    // eslint-disable-next-line
    return () => {
      isMounted = false;
    };
  }, [setRedirectUrl]);

  const handleDelete = async (condominiumId) => {
    try {
      await remove(condominiumId);
      mutate();
      Toast.fire({
        type: "success",
        title: "Condominio eliminado satisfactoriamente.",
      });
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const handleEdit = async (condominiumId) => {
    setRedirectUrl(`/dashboard/condominiums/${condominiumId}`);
    setRedirect(true);
  };

  const isSelectedCondominium = (condominium) => {
    if (selectedCondominium === condominium.condominium_id) {
      return;
    }
    dispatch(
      SelectCondominium(
        condominium.condominium_id,
        condominium.name,
        condominium.address,
        condominium.identification
      )
    );
  };

  const notPermission = () => {
    Swal.fire({
      text: "Para seguir disfrutando del servicio, debes estar mantenerte solvente.",
      confirmButtonText: "Ok, entiendo.",
      confirmButtonColor: "#950ec3",
      html: `<div class="shadow-none mb-3 card">
                    <img src="${bg}" class="card-img-top w-75 align-self-center">
                    <div class="card-body">
                        <h3 class="font-weight-semi-bold">
                        ¡Servicio agotado!
                        </h3>
                        <p>Para seguir disfrutando del  <strong class='text-primary'>servicio</strong>, debes mantenerte solvente.</p>
                        <p>
                            Te recomiendo <strong class='text-success'>estar al día</strong> 
                            con tus deudas del sistema para así seguir
                            <strong class='text-default'><i>disfrutando de las comodidades</i></strong> que ofrecemos para ti.
                        </p>
                            <div class="text-center">
                                <a href='/dashboard/app' class="my-3 btn btn-info btn-lg">
                                    Solventar deudas
                                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-circle-right" class="svg-inline--fa fa-arrow-circle-right fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"></path></svg>
                                    <em className='fas fa-arrow-right'/>
                                </a>
                                <small class="d-block">
                                    Si hay una falla técnica, porfavor contactanos.
                                    <a href="/dashboard/support" class="ml-1">
                                        Soporte de Homelan
                                    </a>
                                </small>
                            </div>
                        </div>
                   </div>`,
    });
  };

  const handleSeeBanks = (condominiumId) => {
    setRedirectUrl(`/dashboard/banks/${condominiumId}`);
    setRedirect(true);
  };

  const handleSeeProperties = (condominiumId) => {
    setRedirectUrl(`/dashboard/properties`);
    setRedirect(true);
  };

  const handleSeeAlicuota = () => {
    setRedirectUrl(`/dashboard/aliquots`);
    setRedirect(true);
  };

  const renderCondominiums = () => {
    return data.map((condominium, i) => {
      const solved = condominium.banned;
      return (
        <ListItem
          onClick={() =>
            solved ? notPermission() : isSelectedCondominium(condominium)
          }
          avatar={
            condominium.image
              ? `${import.meta.env.VITE_URL}/storage/${condominium.image}`
              : null
          }
          key={i}
          options={true}
          title={condominium.name}
          status={condominium.status}
          solved={condominium.banned}
          acronym={condominium.acronym}
          alternativeName={"condominio"}
          id={condominium.condominium_id}
          createdAt={condominium.created_at}
          condominiumId={condominium.condominium_id}
          onChangeMoney={() => setOpenModalSelectMoney(true)}
          onEditAction={() => handleEdit(condominium.condominium_id)}
          onSeeAction={() => handleSeeBanks(condominium.condominium_id)}
          onSeeProperties={() => handleSeeProperties(condominium.condominium_id)}
          onSeeAlicuota={() => handleSeeAlicuota()}
          onDeleteAction={() => handleDelete(condominium.condominium_id)}
          propertiesCount={condominium.properties_count}
          pricesConfig={prices}
        />
      );
    });
  };

  return (
    <>
      <Card className="mb-3">
        <CardBody>
          <FontAwesomeIcon icon={faExclamation} className="mr-2" />
          Haga click en un condominio para seleccionarlo y empezar a
          administrarlo.
        </CardBody>
      </Card>
      <Card>
        <FalconCardHeader title={title}>
          <Row className="mb-2">
            <Col className="pr-0">
              <Flex align="center">
                <Label className="mb-0 mr-2">Filtrar</Label>
                <Input
                  type="select"
                  onChange={({ target }) =>
                    target.value === "true"
                      ? setParams((prev) => ({ ...prev, banned: true }))
                      : target.value === "false"
                        ? setParams((prev) => ({ ...prev, banned: false }))
                        : setParams((prev) => ({ ...prev, banned: "all" }))
                  }
                >
                  <option value="all">Todos</option>
                  <option value={false}>Activos</option>
                  <option value={true}>Desactivados</option>
                </Input>
              </Flex>
            </Col>
            <Col
              xs={12}
              md={"auto"}
              className="mt-3 mt-md-0 text-center text-md-right"
            >
              <ButtonIcon
                onClick={() => {
                  setRedirectUrl(`/dashboard/condominiums/create`);
                  setRedirect(true);
                }}
                icon={"plus"}
                color={"falcon-default"}
              >
                Añadir condominio{" "}
              </ButtonIcon>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex">
              <Input
                type="text"
                value={textSearch}
                onKeyDown={(e) => {
                  if (e.key !== "Enter") return;
                  const value = e.currentTarget.value.trim();
                  setTextSearch(value);
                  setParams((rest) => ({ ...rest, search: value || null }));
                }}
                onChange={(event) => {
                  const value = event.target.value;
                  setTextSearch(value);
                  if (value.trim() === "") {
                    setParams((rest) => ({ ...rest, search: null }));
                  }
                }}
                placeholder="Nombre, sigla, identificación o dirección..."
                className="d-inline-block search-input mr-2"
              />
              <Button
                className="d-inline-block"
                color={"falcon-default"}
                onClick={() => {
                  const value = textSearch.trim();
                  setTextSearch(value);
                  setParams((rest) => ({ ...rest, search: value || null }));
                }}
              >
                Buscar
              </Button>
            </Col>
          </Row>
        </FalconCardHeader>
        <CardBody
          className={classNames("fs--1", { "p-0": isIterableArray(data) })}
        >
          <PreloadState loading={isLoading} cond={isIterableArray(data)}>
            <Or value={true}>
              <ul className="list-unstyled">{renderCondominiums()}</ul>
            </Or>
            <Or value={false} cond={!!error}>
              <Or value={false} cond={!!textSearch[0]}>
                <Message
                  value={true}
                  color={"info"}
                  className="p-3"
                  align="left"
                  icon={faInfoCircle}
                >
                  <>
                    No hemos encontrado un condominio con el nombre "
                    {textSearch}".
                  </>
                </Message>
                <Message
                  value={false}
                  color={"info"}
                  className="p-3"
                  align="left"
                  icon={faInfoCircle}
                >
                  <>
                    Al parecer aún no has creado un condominio, Puedes crear uno
                    ahora mismo pulsando el siguiente enlace
                    <Button
                      data-testid="Button"
                      color="link"
                      size="sm"
                      className="pl-0 ml-1"
                      onClick={() => setRedirect(true)}
                    >
                      Crear condominio
                    </Button>
                  </>
                </Message>
              </Or>
            </Or>
          </PreloadState>
        </CardBody>
        <CardFooter>
          {isIterableArray(data) && (
            <FullPagination
              nextPage={nextPage}
              prevPage={previousPage}
              goToPage={goToPage}
              meta={meta}
              className={"shadow-none"}
              posText={"condominios"}
              perPage={perPage}
            />
          )}
        </CardFooter>
      </Card>
      <ModalSelectedMoneyType
        open={openModalSelectMoney}
        toggle={() => setOpenModalSelectMoney(false)}
      />
    </>
  );
};

CondominiumList.propTypes = {
  showPagination: PropTypes.bool,
};


export default withRedirect(CondominiumList);